import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useGetProductionProjectByAlias } from "../../query/ProductionQuery";
import { Spin, Tabs } from "antd";
import NotFound from "../NotFound/NotFound";
import dayjs from "dayjs";
import ProductionProjectInfoTab from "../../components/production/ProductionProjectInfoTab";
import ProductionPurchaseRequestTab from "../../components/production/ProductionPurchaseRequestTab";
import ProductionProjectPhaseTab from "../../components/production/ProductionProjectPhaseTab";
import ProductionProjectDocument from "../../components/production/ProductionProjectDocument";

const ProductionProjectDetail = () => {
  const { alias } = useParams<{ alias: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<string>("info");
  const { data: project, isLoading } = useGetProductionProjectByAlias(alias!);
  useEffect(() => {
    const tab = searchParams.get("tab");
    if (
      tab &&
      ["info", "purchase-request", "document", "phase"].includes(tab)
    ) {
      setActiveTab(tab);
    }
  }, [searchParams]);

  if (isLoading || !project) {
    return (
      <div className="p-4 flex justify-center items-center h-screen">
        <Spin size="large" />
      </div>
    );
  }
  if (!alias) {
    return <NotFound />;
  }
  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <div className="text-xl font-bold">
          {project?.project} - {project?.projectName}
        </div>
        <div className="flex gap-2 items-center text-sm">
          <span>
            Ngày tạo: {dayjs(project?.requestDate).format("DD/MM/YYYY")}
          </span>
          <span>|</span>
          <span>Yêu cầu từ: {project?.requestFrom}</span>
        </div>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
          const params = new URLSearchParams(searchParams);
          params.set("tab", key);
          setSearchParams(params);
        }}
        items={[
          {
            key: "info",
            label: "Thông tin chung",
            children: <ProductionProjectInfoTab alias={alias} />,
          },
          {
            key: "purchase-request",
            label: "Hàng đặt mua",
            children: <ProductionPurchaseRequestTab alias={alias} />,
          },
          {
            key: "phases",
            label: "Timeline",
            children: <ProductionProjectPhaseTab alias={alias} />,
          },
          {
            key: "document",
            label: "Tài liệu",
            children: <ProductionProjectDocument alias={alias} />,
          },
        ]}
      />
    </div>
  );
};

export default ProductionProjectDetail;
